import { isNullish } from '@sas/nova-core/typeguards';
const billions = 'formatNumber.b.msg';
const millions = 'formatNumber.m.msg';
const thousands = 'formatNumber.k.msg';
const numberFormat = (formatLocale, maxFractionDigits = 1) => new Intl.NumberFormat(formatLocale, {
  maximumFractionDigits: maxFractionDigits
});
export const formatBoolean = props => {
  const {
    localize,
    value,
    defaultFormattedValue
  } = props;
  if (isNullish(value)) return defaultFormattedValue ? defaultFormattedValue : '';
  return localize(`boolean.${value}.msg`);
};
export const formatNumber = props => {
  const {
    formatLocale,
    localize,
    value,
    defaultFormattedValue
  } = props;
  const ranges = [{
    divider: 1e18,
    siSymbol: 'E',
    abbrevKey: ''
  }, {
    divider: 1e15,
    siSymbol: 'P',
    abbrevKey: ''
  }, {
    divider: 1e12,
    siSymbol: 'T',
    abbrevKey: ''
  }, {
    divider: 1e9,
    siSymbol: 'G',
    abbrevKey: billions
  }, {
    divider: 1e6,
    siSymbol: 'M',
    abbrevKey: millions
  }, {
    divider: 1e3,
    siSymbol: 'k',
    abbrevKey: thousands
  }];
  if (isNullish(value) || isNaN(value)) return defaultFormattedValue ? defaultFormattedValue : '';
  for (let i = 0; i < ranges.length; i++) {
    if (value >= ranges[i].divider) {
      const rVal = numberFormat(formatLocale).format(value / ranges[i].divider);
      if (ranges[i].abbrevKey.length > 0) {
        return localize(ranges[i].abbrevKey, {
          value: rVal
        });
      } else {
        return rVal;
      }
    }
  }
  return numberFormat(formatLocale).format(value);
};
export const valueToDate = value => {
  if (Object.prototype.toString.call(value) === '[object Date]') {
    return value;
  }
  if (typeof value === 'string' && !isNaN(Date.parse(value))) {
    return new Date(value);
  }
  return null;
};

//  [2021-10-21 TO 2021-10-28]
export const formatDateRangeForSearch = opts => {
  return `[${formatSingleDateForSearch(opts.startDate)} TO ${formatSingleDateForSearch(opts.endDate)}]`;
};

// format: 2021-10-21 using local time (we must pass along timezone information)
const formatSingleDateForSearch = date => {
  const timeless = new Date(date.toDateString());
  const day = timeless.getDate();
  const dayStr = day < 10 ? `0${day}` : day;
  const month = timeless.getMonth() + 1; // who uses a zero-based month?
  const monthStr = month < 10 ? `0${month}` : month;
  const year = timeless.getFullYear();
  return `${year}-${monthStr}-${dayStr}`;
};
export const formatNumericRangeForSearch = opts => {
  if (opts.valueType === 'integer' || opts.valueType === 'long') {
    return `[${opts.start.toFixed(0)} TO ${opts.end.toFixed(0)}]`;
  }
  return `[${opts.start.toFixed(2)} TO ${opts.end.toFixed(2)}]`;
};
//# sourceMappingURL=format.js.map